import React from 'react';

import ReactPaginate from 'react-paginate';
import i18next from 'i18next';

import './style.scss';

const Paginate = ({ currentPage, totalPages, setCurrentPage, previousLabel = i18next.t('paginate_prev'), nextLabel = i18next.t('paginate_next') }) => {

  const prev = () => {
    return (
      <><div className="icon icon-caret icon-variant-1 icon-reverse" /> <span>{previousLabel}</span></>
    );
  };
  const next = () => {
    return (
      <><span>{nextLabel}</span> <div className="icon icon-caret icon-variant-1" /></>
    );
  };

  const pageChange = ((data) => {
    if (setCurrentPage) {
      setCurrentPage(data.selected);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  });

  if (totalPages === 0) {
    return null;
  }

  return (
    <div className="pager">
      <ReactPaginate
        previousLabel={prev()}
        nextLabel={next()}
        breakLabel="..."
        breakClassName="break-me"
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={4}
        disabledClassName="disabled"
        initialPage={currentPage}
        onPageChange={pageChange}
        containerClassName="pagination"
        subContainerClassName="pages pagination"
        activeClassName="active"
      />
    </div>
  );

};
export default Paginate;
